// extracted by css-extract-rspack-plugin
export default {"selectedOption":"gojs5","option":"ZPH02","actionsList":"rrgna"};